<template>
    <div :class="(opciones.paddingDefault.aplicar) ? 'container-fluid espacio' : 'container-fluid'" :style="opciones.paddingDefault.css">
        <div id="seccion-tipo-documento">
            <!-- FILTRO TIPO DE DOCUMENTO -->
            <div v-if="opciones.titulo.mostrar" id="tipos-documento" class="form-inline">
                <div>
                    <h3 id="titulo-filtros">{{ opciones.titulo.nombre }}&nbsp;&nbsp;
                        <i v-if="opciones.esClinica" id="i-cambio-fecha" 
                           @click="accionModalCambioDeFecha({ mostrar: true })" 
                           class="fas fa-calendar-week"
                           v-tooltip:right="'Filtrar por año'"></i>
                    </h3>
                </div>
                <div v-for="(tipoDocumento,index) in opciones.tiposDeDocumentos" :key="'fdoc' + index" class="mr-3">
                    <div class="btn-filtro form-inline" @click="activarFiltro(tipoDocumento)" :id="ID_BASE_TIPO_DOCUMENTO + tipoDocumento.tipoId">
                        <h6>{{ tipoDocumento.nombre }}</h6>
                    </div>
                </div>
            </div>
            <!-- FILTROS DE BUSQUEDA -->
            <!-- <div v-if="opciones.filtrosBusqueda.mostrar" id="filtros-busqueda" class="row mt-4">
                
                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pt-1 pr-2">
                    <div class="input-group">
                        <div class="input-group-append">
                            <div class="input-group-text"><i class="fa fa-search"></i></div>
                        </div>
                        <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="search" placeholder="Buscar documento">
                    </div>
                </div>
                
                <div id="filtro-estatus" class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pt-1 pr-2">
                     <select class="form-control">
                        <option value="-1">Estatus</option>
                        <option value="1">Activo</option>
                        <option value="2">Inactivo</option>
                    </select>  
                </div>
                
                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pt-1 pr-2">
                    <div class="input-group">
                        <div class="input-group-append">
                            <div class="input-group-text"><i class="fa fa-file"></i></div>
                        </div>
                        <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" placeholder="Tipo de archivo">
                    </div>
                </div>
                
                <div id="filtro-fecha" class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pt-1 pr-2">
                    <datepicker
                        :key="filtrosBusqueda.propiedades.KEY + filtrosBusqueda.propiedades.contRender" 
                        :format="filtrosBusqueda.DatePickerFormato"  
                        v-model="filtrosBusqueda.propiedades.fecha"
                        @selected="evtSeleccionDeFechaDtPk"  
                        :value="filtrosBusqueda.propiedades.fechaDefault" 
                        :bootstrap-styling="true"
                        :calendar-button="true"
                        calendar-button-icon="far fa-calendar-alt"  
                        :class="{'texto-negro': true}" name="fecha" 
                        :language="filtrosBusqueda.propiedades.lenguaje"></datepicker>
                </div>
                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pt-1 pr-2">
                    <button class="btn btn-primary" @click="evtBuscar">Buscar</button>
                </div>
            </div> -->
            <!-- LISTADO DE DOCUMENTOS -->
            <CNoSeEncontraronResultados class="mt-4" v-if="!this.campoRequeridoEsValido(documentos)" :opciones="{ tituloBusqueda: 'Búsqueda en documentos', NombreSeccion: 'Documentos' }"></CNoSeEncontraronResultados>
            <div v-if="this.campoRequeridoEsValido(documentos)" id="contenedor-listado" :class="(opciones.filtrosBusqueda.mostrar) 
                ? 'table-responsive container-fluid pl-0 m-contenedor-listado-6' : 'table-responsive container-fluid pl-0 m-contenedor-listado-3'">
                <table
                    class="table borderless table-light table-hover"
                    id="tabla-documentos"              
                    data-toggle="table"
                    data-pagination="true"
                    data-undefined-text="Sin información"
                    data-maintain-selected="true"  
                    data-page-size = "5"
                    data-page-list="[5,10,20]"
                    data-click-to-select="false"
                    data-show-toggle="true"
                    data-show-pagination-switch="true"
                    data-search="true">
                    <thead class="thead-light">
                        <tr>
                            <!-- <th id="tabla-contenidos-seleccionar-todo" data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th> -->
                            <th data-halign="center" data-width="20" data-align="center" data-field="Nombre" data-sortable="true">
                                Nombre
                            </th>
                            <th data-halign="center" data-width="5" data-align="center" data-field="Extension" data-sortable="true">
                                Extension
                            </th>
                            <th data-halign="center" data-width="30" data-align="center" data-field="Archivo" data-sortable="true">
                                Archivo
                            </th>
                            <th data-halign="center" data-width="20" data-align="center" data-field="Fecha" data-sortable="true">
                                Registro
                            </th>
                            <th data-halign="center" data-width="15" data-align="center" data-field="Tipo" data-sortable="true">
                                Tipo
                            </th>
                            <th data-events="operateEvents" data-width="15" :data-formatter="this.formateadorHTMLAcciones()" data-halign="center" data-align="center">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <!-- MODAL INFORMATIVO -->
            <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-cambio-fecha">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">INGRESA EL AÑO</h4><i class="fas fa-calendar-week"></i>
                        </div>
                        <div class="modal-body pl-4 pr-4 pt-4 pb-0">
                            <div class="form-group">
                                <select class="form-control" @change="cambioTiempo($event)">
                                    <option value="-1">Selecciona un año</option>
                                    <option v-for="(tiempo, index) in tiemposSesiones" :key="index" :value="tiempo.clave">{{ tiempo.texto }}</option>
                                </select>
                            </div>
                            <div id="acciones-modal" class="d-flex justify-content-end">
                                <h6 style="margin-right: 2em;" @click="accionModalCambioDeFecha({ mostrar: false })">Cancelar</h6>
                                <h6 @click="cambiarFechaDeClinicas">Buscar</h6>
                            </div>
                        </div>             
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import api from '@/../static/js/api'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import CNoSeEncontraronResultados from '../Comun/CNoSeEncontraronResultados.vue'

export default {
    directives: {
        tooltipF
    },
    props: {
        idContenedor: {
            type: Number,
            default: 0
        },
        documentos: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
                paddingDefault: { aplicar: true, css: '' },
                filtrosBusqueda: { mostrar: true },
                titulo: { mostrar: true, nombre: 'Documentos' },
                tiposDeDocumentos: [
                    { tipoId: 1, nombre: 'Notas', activo: true }
                ],
                tipoDeDocumentoSeleccionado: 'Todos',
                esClinica: false
            })
        },
    },
    components: {
        Datepicker: Datepicker,
        CNoSeEncontraronResultados: CNoSeEncontraronResultados
    },
    data() {
        return {
            ID_BASE_TIPO_DOCUMENTO: 'tipo-documento-',
            filtrosBusqueda: {
                DatePickerFormato: 'yyyy-MM-dd',
                lenguaje:{
                    language: 'es',
                    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                    days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                    rtl: false,
                    ymd: 'yyyy-MM-dd',
                    yearSuffix: ''
                },
                propiedades: {
                    KEY: 'DTPCKinicioIntranet',
                    contRender: 0,
                    fecha: new Date(),
                    fechaSeleccionada: 0,
                    fechaDefault: new Date(),
                },
            },
            documentosFomartoHTML: [],
            tiemposSesiones: [],
            tiempoSeleccionado: null,
            listadoDeClinicasTMP: []
        }
    },
    methods: {
        cambiarFechaDeClinicas: async function() { 
            let buscarPor = (this.campoRequeridoEsValido(this.tiempoSeleccionado)) ? this.tiempoSeleccionado : -1;
            await Promise.resolve(this.aplicarFiltradoDeClinicasPorTiempo({ tiempo: buscarPor }));
            this.accionModalCambioDeFecha({ mostrar: false });
        },
        cambioTiempo: function(evento) { 
            this.tiempoSeleccionado = parseInt(evento.target.value);
        },
        accionModalCambioDeFecha: function({ mostrar }) {
            const ACCION = (mostrar) ? 'show' : 'hide';
            $("#modal-cambio-fecha").modal(ACCION);
        },
        aplicarFiltradoDeClinicasPorTiempo: async function({ tiempo }) { 
            if(this.campoRequeridoEsValido(this.documentos) && this.campoRequeridoEsValido(tiempo)) 
                this.listadoDeClinicasTMP = this.documentos.filter(clinicaTemporal => moment(clinicaTemporal.Fecha).format('YYYY') == tiempo);
            else
                this.listadoDeClinicasTMP = this.documentos;

            this.inicializarTabla({ documentos: this.listadoDeClinicasTMP });
        },
        construirTiempoEnOpciones: async function() { debugger
            if(this.campoRequeridoEsValido(this.documentos)) {
                this.tiemposSesiones = this.documentos.map(clinica => {
                    let tiempoObj = {};
                    let tiempoDeClinica = moment(clinica.Fecha).format('YYYY');
                    tiempoObj.clave = parseInt(tiempoDeClinica);
                    tiempoObj.texto = tiempoDeClinica;
                    return tiempoObj;
                });
                // se eliminan los años duplicados
                if(this.campoRequeridoEsValido(this.tiemposSesiones)) {
                    this.tiemposSesiones = this.tiemposSesiones.filter((tiempo, index, self) =>
                        index === self.findIndex((t) => (
                            t.clave === tiempo.clave
                        ))
                    );

                    // se ordena del menor al mayor
                    this.tiemposSesiones = this.tiemposSesiones.sort((a, b) => a - b );
                }
            }
        },
        ajustarTexto: function({ textoParaAjustar, numeroDeCaracteres }) { 
            let textoAjustado = textoParaAjustar;
            if(this.campoRequeridoEsValido(textoParaAjustar) && this.campoRequeridoEsValido(numeroDeCaracteres)) {
                const LONGITUD_TEXTO = textoParaAjustar.length;
                if(LONGITUD_TEXTO > numeroDeCaracteres) {
                    textoAjustado = `${ textoAjustado.substring(0,numeroDeCaracteres) } ...`;
                }
            }
            return textoAjustado;   
        },
        evtBuscar: function() {
            $("#tabla-documentos").on("toggle.bs.table", () => {
               
            });
        },
        evtSeleccionDeFechaDtPk: function() {

        },
        activarFiltro: function(tipoDocumento) {  debugger
        console.log('entro::actvFilt::', tipoDocumento.nombre.toUpperCase() == 'TODOS')
            if(this.campoRequeridoEsValido(tipoDocumento)) {
                this.$nextTick(() => {
                    this.opciones.tiposDeDocumentos.filter(tp => tp.tipoId != tipoDocumento.tipoId).forEach(tpd => {
                        tpd.activo = false;
                        $("#" + this.ID_BASE_TIPO_DOCUMENTO + tpd.tipoId).removeClass('filtro-activo');
                    });
                    if(tipoDocumento.activo)
                        $("#" + this.ID_BASE_TIPO_DOCUMENTO + tipoDocumento.tipoId).removeClass('filtro-activo');
                    else
                        $("#" + this.ID_BASE_TIPO_DOCUMENTO + tipoDocumento.tipoId).addClass('filtro-activo');
                    tipoDocumento.activo = !tipoDocumento.activo;
                });

                let documentosFiltrados = [];
                if(this.campoRequeridoEsValido(tipoDocumento.nombre) && tipoDocumento.nombre.toUpperCase() == 'TODOS') {
                    documentosFiltrados = this.documentos.filter(d => true);
                }
                else {
                    documentosFiltrados = this.documentos.filter(d => d.ContenidoAlQuePerteneceId == tipoDocumento.tipoId);
                }
                this.inicializarTabla({ documentos: documentosFiltrados });
            }
        },
        darFormatoHTMLDocumentos: async function({ documentosAConvertir }) { debugger
            this.documentosFomartoHTML = documentosAConvertir.map(d => { 
                let docHTML = {};
                //Nombre: 'Nota 1', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota'
                docHTML.Nombre = `<h5 style="color: #676666; font-weight: bold; font-size: 2vmin;" class="align-middle">
                                    <i class="fas fa-file-alt" style="font-size: 3vmin; color: #676666;"></i>&nbsp;&nbsp;${ d.Nombre }
                                  </h5>`;
                let coloresExtension = this.obtenerColorExtension({ extensionSTR: d.Extension });
                docHTML.Extension = `<div style="display: flex; justify-content: center;" class="align-middle">
                                        <div style="${ coloresExtension.FONDO } width: max-content; ${ coloresExtension.TEXTO } border-radius: 2em; padding: 1vmin 1vmin 0.1vmin 1vmin;">
                                            <h6 style="font-weight: bold; font-size: 2vmin;">${ d.Extension }</h6>
                                        </div>
                                     </div>`;
                docHTML.Archivo = `<h5 style="color: #676666; font-weight: bold; font-size: 2.3vmin;" class="align-middle">${ d.Archivo }</h5>`;
                docHTML.Fecha = `<div class="form-inline justify-content-center class="align-middle" pb-1">
                                    <div style="background-color: #CDCCCC; text-align: center; width: 5vmin; height: 5vmin; display: flex; justify-content: center; align-items: center; border-radius: 25px; padding-top: 1vmin; margin-right: 2vmin;">
                                        <h5 style="color: #676666; font-weight: bold; font-size: 3vmin;">${ d.InicialesUsuario }</h5>
                                    </div>
                                    <div style="margin-top: 1vmin;">
                                        <h5 style="font-weight: bold; color: #676666; font-size: 2.3vmin;">${ d.usuario }</h5>
                                        <h6 style="font-weight: bold; color: #A8A3A3; margin-top: -1vmin; font-size: 1.8vmin;">${ d.Fecha }</h6>
                                    </div>
                                 </div>`;
                docHTML.Tipo = `<div style="display: flex; text-align: center; justify-content: center;" class="pb-1">
                                    <div style="background-color: #ECE6E6; color: black; width: max-content; border-radius: 0.5em; padding: 0.5vmin 2vmin 0.1vmin 2vmin;">
                                        <h6 style="font-weight: bold; font-size: 2.1vmin;">${ this.ajustarTexto({ textoParaAjustar : d.Tipo, numeroDeCaracteres: 12 }) }</h6>
                                    </div>
                                </div>`;
                docHTML.RutaParaDescarga = d.RutaParaAccesar;
                return docHTML;
            });
        },
        obtenerColorExtension: function({ extensionSTR }) {
            let color = { FONDO: 'background-color: #F4DFDF;', TEXTO: 'color: #A72525;' };
            if(extensionSTR == 'PDF')
                color = { FONDO: 'background-color: #F4DFDF;', TEXTO: 'color: #A72525;' };
            else if(extensionSTR == 'DOC' || extensionSTR == 'DOCX')
                color = { FONDO: 'background-color: #5b78af;', TEXTO: 'color: rgb(1, 33, 59);' };
            else if(extensionSTR == 'PNG' || extensionSTR == 'JPG' || extensionSTR == 'JPEG')
                color = { FONDO: 'background-color: #fcdcc7;', TEXTO: 'color: #572300;' };
            else if(extensionSTR == 'XLS')
                color = { FONDO: 'background-color: #78948b;', TEXTO: 'color: #003a28;' };
            return color;
        },
        descargarArchivoDeDocumento: function({ documento }) { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ documento.RutaParaDescarga }`
            a.click();
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        activarCarviewEnTabla: function() {
            let windowSize = $(window).width(); 
            if(windowSize < 1130){
                $("#tabla-documentos").bootstrapTable('toggleView');
            }
            else {
                $("#tabla-documentos").bootstrapTable('showColumn', 'Nombre');
            }
        },
        formateadorHTMLAcciones: () => {
            return [
            '<div>',
            '<button id="descargar-documento-intranet-CCLDOC" type="button" class="btn btn-light btn-sm btn-xs btn-lg btn-md"><i class="fas fa-download"></i>&nbsp;Descargar</button>',
            '</div>'
            ].join("");
        },
        inicializarTabla: async function({ documentos }) {
            await Promise.resolve(this.darFormatoHTMLDocumentos({ documentosAConvertir: documentos }))
            this.$nextTick(() => {
                $("#tabla-documentos").bootstrapTable({  data: this.documentosFomartoHTML });      
                $("#tabla-documentos").bootstrapTable('load', this.documentosFomartoHTML ); 

                this.activarCarviewEnTabla();

                $(window).on('resize',(event) => {
                    this.activarCarviewEnTabla();
                });
            });
        },
        aplicarFiltroInicialTipoDocumentos: function() {  debugger
            if(this.campoRequeridoEsValido(this.opciones.tipoDeDocumentoSeleccionado)) { 
                const TIPOS_DE_DOCUMENTOS = this.opciones.tiposDeDocumentos.filter(d => true);
                const DOCUMENTO_URL = TIPOS_DE_DOCUMENTOS.find(td => td.nombre.toUpperCase().replace(/\s/g,'') == this.opciones.tipoDeDocumentoSeleccionado.toUpperCase().replace(/\s/g,''));
                let documentoParaActivar = this.campoRequeridoEsValido(DOCUMENTO_URL) ? { tipoId: DOCUMENTO_URL.tipoId, nombre: DOCUMENTO_URL.nombre, activo: false } : { tipoId: -1, nombre: 'Todos', activo: false };
                this.activarFiltro(documentoParaActivar);
            }
        }
    },
    mounted() {
        window.operateEvents = {
            "click #descargar-documento-intranet-CCLDOC": (e,val,row,index) => {   
                this.descargarArchivoDeDocumento({ documento: row });
            },
        };
    },
    created() { 
    },
    computed: {
        obtenrUrlArea() {
            return this.$route.path;
        }
    },
    watch: {
        'opciones.tiposDeDocumentos': function() {
            this.$nextTick(() => {
                const FILTRO_INICIAL_TIPO_DOC = this.opciones.tiposDeDocumentos.find(tp => tp.activo);
                if(this.campoRequeridoEsValido(FILTRO_INICIAL_TIPO_DOC)) {
                    $("#" + this.ID_BASE_TIPO_DOCUMENTO + FILTRO_INICIAL_TIPO_DOC.tipoId).addClass('filtro-activo');  
                }    
                this.aplicarFiltroInicialTipoDocumentos(); 
            });
        },
        'documentos': async function() {
            const DOCUMENTOS = (this.opciones.esClinica) ? this.listadoDeClinicasTMP : this.documentos;
            this.inicializarTabla({ documentos: DOCUMENTOS });
            if(this.opciones.esClinica) {
                this.$nextTick(async () => {
                    await Promise.resolve(this.construirTiempoEnOpciones());
                    const TIEMPO_MAS_RECIENTE = (this.campoRequeridoEsValido(this.tiemposSesiones)) ? this.tiemposSesiones[0] : -1;
                    await Promise.resolve(this.aplicarFiltradoDeClinicasPorTiempo({ tiempo: TIEMPO_MAS_RECIENTE.clave }));
                });
            }
        }
    },
}
</script>
<style scoped>
#acciones-modal h6 {
    color: rgb(49, 49, 49) !important;
    font-weight: bold;
    cursor: pointer;
}

#acciones-modal h6:hover, #acciones-modal h6:focus {
    color: #be9a5e !important;
}

#acciones-modal {
    margin-top: 2em;
    padding-bottom: 1em;
}

#i-cambio-fecha {
    font-size: 3.5vmin;
    color: #be9a5e;
    cursor: pointer;
}

#modal-cambio-fecha .modal-lg {
    max-width: 35% !important;
    z-index: 9999999999999999999999999999999999999;
}

#modal-cambio-fecha .modal-content {
    background-color: #FFFFFF;
    box-shadow: 0px 6px 20px 8px #424242;
}

#modal-cambio-fecha .modal-content .form-control{
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
}

#modal-cambio-fecha .modal-header {
    background-color: rgb(49, 49, 49);
    border: none;
    color: white;
    display: flex;
    align-items: center;
}

.scroll-tipos-documentos {
    overflow: auto;
    white-space: nowrap;
    max-width: 100px;
}

.kkk {
    font-weight: bold;
    color: #A8A3A3;
    width: max-content;
}
#filtros-busqueda .btn {
    border-radius: 2em;
}

#contenedor-listado {
    /* margin-top: 6vmin; */
}

.m-contenedor-listado-6 {
    margin-top: 6vmin;
}

.m-contenedor-listado-3 {
    margin-top: 2vmin;
}

#filtros-busqueda .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
}

#tabla-documentos table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

#filtros-busqueda .input-group-text {
    border-top-left-radius: 0.6vmin;
    border-bottom-left-radius: 0.6vmin;
}

#filtros-busqueda .form-control:focus {
    box-shadow: none;
}

#filtros-busqueda .form-control::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #AF9C9C;
  opacity: 1; /* Firefox */
  font-weight: bold;
}

#filtros-busqueda .form-control:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #AF9C9C;
  opacity: 1; /* Firefox */
  font-weight: bold;
}

#filtros-busqueda .form-control::-ms-input-placeholder { /* Microsoft Edge */
  color: #AF9C9C;
  opacity: 1; /* Firefox */
  font-weight: bold;
}

#filtros-busqueda .input-group-text {
    background-color: #676666;
    color: #FFFFFF;
    border: 1px solid #656161;
}

.btn-filtro {
    background-color: #FFFFFF;
    border: 1px solid #656161;
    color: #8E8A8A;
    border-radius: 9px;
    width: max-content;
    height: 5vmin;
    border-radius: 10vmin;
    padding: 1vmin 2vmin 1vmin 2vmin;
    cursor: pointer;
}

.btn-filtro h6 {
    font-size: 2vmin;
}

.btn-filtro:hover, .btn-filtro:focus, .btn-filtro:active {
    background-color: #676666;
    border: 1px solid #656161;
    color: #FFFFFF;
}

.filtro-activo {
    background-color: #676666;
    border: 1px solid #656161;
    color: #FFFFFF;
}

@media screen and (max-width: 400px) {
    #seccion-tipo-documento {
        flex-direction: column;
        align-self: flex-start;
    }

    #seccion-tipo-documento div {
        margin-bottom: 2px;
    }
}

.espacio {
    padding: 5vmin 16vmin 5vmin 16vmin;
}

#titulo-filtros {
    color: #000000;
    font-size: 4vmin;
    font-weight: bold;
    margin-right: 3vmin;
}
</style>
<style>
#filtro-fecha .vdp-datepicker
  {
      min-width: 30%;
      max-width: 80%;
      width: auto;
  }
  #filtro-fecha .vdp-datepicker__calendar{
      color:black ;
  }
  #filtro-fecha span.day-header{
      font-size: 0.9rem !important;
  }
  #filtro-fecha .vdp-datepicker__calendar .cell.selected {
    background: rgb(109, 110, 110) !important;
  }
  #filtro-fecha .vdp-datepicker__calendar .cell.highlighted {
    background: #afb0b1 !important;
  }
  #filtro-fecha .vdp-datepicker__calendar .cell.selected.highlighted {
    background: rgb(109, 110, 110) !important;
  }
  #filtro-fecha .vdp-datepicker__calendar .cell.disabled{
    color:#666666 !important;
  }
  #filtro-fecha .vdp-datepicker__calendar .cell.selected.disabled {
    color:#333333 !important;
  }
  #filtro-fecha .vdp-datepicker>.input-group>.form-control[readonly]{
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    font-size: 0.9rem;
    padding: 0 .75rem;
    box-shadow: none;
    /* height: calc(2rem); */
  }
  #filtro-fecha .vdp-datepicker__calendar .cell:not(.disabled):not(.day-header):not(.blank):hover {
    border-color: #1F1F21 !important;
  }
  #filtro-fecha .day__month_btn {
    font-size: 0.9rem !important;
  }
  #filtro-fecha .vdp-datepicker__calendar-button>.input-group-text{
    border:none;
    background-color: #666666;
    color: #FFF;
  }
  #filtro-fecha .vdp-datepicker__calendar-button>.input-group-text:hover{
      background-color: #999999;
      color:black;
  }

#contenedor-listado .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 50vmin;
}

#contenedor-listado td {
    background-color: white;
    vertical-align: middle;
}

.borderless td, .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

#contenedor-listado th {
    background-color: rgb(59, 59, 59) !important;
    color: white;
}

#contenedor-listado .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 2vmin;
}

#contenedor-listado .btn-light:hover, #contenedor-listado .btn-light:focus {
    background-color: #4F4949;
    border: 1px solid #4F4949;
    color: white;
}

#contenedor-listado table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}


#contenedor-listado .dropdown-toggle {
    width: 3.3rem;
    background-color: white;
    color: black;
}

#contenedor-listado .pagination > li > a {
    background-color: white;
    color: #121213;
}

#contenedor-listado .btn-secondary {
    width: 2.5rem;
    background-color: rgb(59, 59, 59);
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

#contenedor-listado > li > a:focus,
#contenedor-listado > li > a:hover,
#contenedor-listado > li > span:focus,
#contenedor-listado .pagination > li > span:hover
{
    color: #111011;
    background-color: #eee;
    border-color: #ddd;
}

#contenedor-listado .pagination > .active > a {
    color: white;
    background-color:  #676666;
    border: solid 1px #676666;
}

#contenedor-listado .pagination > .active > a:hover {
    background-color:  black;
    border: solid 1px #676666;
} 
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CListaDeDocumentos.vue